<template>
  <div>
    <b-button pill
              @click="putCambiarEstatusSolicitud(data.item)"
              variant="outline-danger"
              v-if="$localStorageService.can('Bj_esp_elim_sol')"
    > <b-icon icon="trash-fill"></b-icon></b-button>
  </div>
</template>

<script>
export default {
  name: "BandejaEliminarSolicitudComponente",
  props: {
    data: Object,
    resource: Object,
  },
  methods: {
    putCambiarEstatusSolicitud(item) {
      var params = {
        idSolicitudEtapa: item.idSolicitudEtapa,
        idPti: item.idPti
      };
      this.$http
          .post(
              this.$api +
              "ptipresuntivo/eliminar/ptiByEspecialista",
              params

          )
          .then(() => {
            this.$swal({
              allowOutsideClick: false,
              allowEscapeKey: false,
              showCancelButton: false,
              icon: "info",
              text: "Se elimino correctamente la solicitud.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            }).then((aceptar) => {
              if (aceptar.value) {
                location.reload();
              }
            })
          })
          .catch((error) => {
            console.error(error);
            this.$swal({
              icon: "error",
              text: "Ocurrió un error durante el proceso.",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          }).finally(() => (this.funcionExtraBandeja(item.idEstatusSolicitud)));
    },
    funcionExtraBandeja(idEstatusSolicitud) {
      this.$emit("_funcionExtra", idEstatusSolicitud);
    },
  }
}
</script>

<style scoped>

</style>
